<template>
	<div><Echart :options="options" id="bottomrightchartotherChart" height="480px" width="100%"></Echart></div>
</template>

<script>
import request from '@/utils/request';
import Echart from '@/common/echart'; // eslint-disable-line no-unused-vars
export default {
	data() {
		return {
			options: {
				tooltip: {
					trigger:'axis',
					axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'line'// 默认为直线，可选为：'line' | 'shadow'
					}
				},
				dataZoom : [
					{
						type: 'slider',//给x轴设置滚动条
						show: true, //flase直接隐藏图形
						xAxisIndex: [0],
						bottom:0,
						height:20,
						showDetail: false,
						startValue: 0,//滚动条的起始位置
						endValue: 15 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
					},
					{
						type: 'inside',//设置鼠标滚轮缩放
						show: true,
						xAxisIndex: [0],
						startValue: 0,
						endValue: 15
					}
				],
				legend: {
					data: ['本周人数', '上周人数', '随访及时率']
				},
				xAxis: [
					{
						type: 'category',
						data:['三高','慢阻肺'],
						axisPointer: {
							type: 'shadow'
						},
						axisLabel: {
							interval: 0, //强制文字产生间隔
							rotate: 45,
							// rotate: 0,
							textStyle: {
								// fontSize: '8'
								fontSize: '10'
							}
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '人数',
						min: 0,
						// max: 8000,
						interval: 1000,
						axisLabel: {
							formatter: '{value} '
						}
					},
					// {
					// 	type: 'value',
					// 	name: '随访及时率',
					// 	min: 0,
					// 	max: 100,
					// 	interval: 10,
					// 	axisLabel: {
					// 		formatter: '{value} %'
					// 	}
					// }
				],
				grid: {
					x: 30, //控制x轴文字与底部的距离
					y2: 80 // y2可以控制倾斜的文字狱最右边的距离，放置倾斜的文字超过显示区域
				},
				series: [
					{
						name: '本周人数',
						type: 'bar',
						barMaxWidth: '10',
						data:[]
					},
					{
						name: '上周人数',
						type: 'bar',
						barMaxWidth: '10',
						data:[]
					},
					// {
					// 	name: '随访及时率',
					// 	type: 'line',
					// 	barMaxWidth: '10',
					// 	yAxisIndex: 1,
					// 	data:[]
					// }
				]
			}
		};
	},
	components: {
		Echart
	},
	created() {
		  request({
		  	url: this.$root.api + `/api/dbz/daping/dpdbzsffw`,
		  	method: 'get',
		  	}).then(res => {
		  	console.log('dpdbzsffw------',res)
			  // this.options.xAxis[0].data=['三高','慢阻肺','糖尿病肾病','眩晕综合征','偏头痛','急性气管炎','慢性肺源性心脏病']
			  // res.data={"nameList":['三高','慢阻肺','糖尿病肾病','眩晕综合征','偏头痛','急性气管炎','慢性肺源性心脏病'],"szvalue":["3565","1552","1658","1568","1458","1303","1256"],"sfjslvalue":["60","50",'60','50','70','55','55'],"bzvalue":["2024","1552",'1220','1221','1155','1105','1106']}
			  this.options.xAxis[0].data=res.data.nameList
			  this.options.series[0].data = res.data.bzvalue
			this.options.series[1].data = res.data.szvalue
			this.options.series[2].data = res.data.sfjslvalue
		  })
	}
};
</script>

<style></style>
